import type {TimeZone} from 'timezones-list';
import timezones from 'timezones-list';
import {doesContainKeywords} from '@Components/event-wizard/event-wizard.helper';
import {getCityFromTzCode, getCLDRTimeZoneName, getGMTLabel, getShortTzCodeText, getTzCodeText} from '@Components/event-wizard/timezone-content/timezone-content.helper';

export const filterTimeZones = (keywords: string): TimeZone[] => {
  if (keywords === '') {
    return timezones;
  }
  return timezones.filter((timezone) => {
    const searchableText = `${getTzCodeText(timezone.tzCode)} ${getShortTzCodeText(timezone.tzCode)} ${getCLDRTimeZoneName(timezone.tzCode)} ${getCityFromTzCode(timezone.tzCode)} ${getGMTLabel(timezone)}`;
    return doesContainKeywords(searchableText, keywords);
  });
};
